import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import './InvitedUsers.css';
import { Button, Card, CardContent, Typography } from "@material-ui/core";
import { TextFieldFormsy } from '@fuse';
import Formsy from "formsy-react";
import { GoogleLogin } from 'react-google-login';
import { MicrosoftLogin } from 'react-microsoft-login';
import Config from '../../../config';
import PropTypes from 'prop-types';
import GoogleIcon from '../../../custom-icons/google-icon';
import axios from 'axios';
import EndpointsGetter from '../common/EndpointsGetter';
import { connect } from 'react-redux';
import { setUserData } from '../../../store/actions/userActions';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    card: {
        width: '100%',
        maxWidth: 400,
        margin: '0 auto'
    }
});

class LoginInvitedUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            canSubmit: false,
            autoLoginInvoked: false
        };

        this.googleLogin = React.createRef();
    }

    componentDidUpdate() {
        const { email } = this.props;
        if (this.isGoogleEmail(email) && !this.state.autoLoginInvoked) {
            this.googleLogin.current.click();
        }
    }

    isGoogleEmail = (email) => {
        let result = false;
        if (email) {
            let emailDomain = email.split('@');
            if (emailDomain[1] === 'gmail.com') {
                result = true;
            }
        }
        return result;
    }

    googleSuccess = (response) => {
        axios.post(EndpointsGetter.getGoogleLoginEndpoint(), response, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                'Fingerprint': this.props.fingerprint
            }
        })
            .then(response => {
                this.props.setLoginSession(response);
                this.setState({ error: null });
            })
            .catch(error => {
                console.log('Google login error: ', error.response);
                this.loginError(error.response);
            });
    }

    microsoftAuthCallback = (error, authData) => {
        if (error) {
            console.log('ms error: ', error);

        } else {
            axios.post(EndpointsGetter.getMicrosoftLoginEndpoint(), authData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                    'Fingerprint': this.props.fingerprint
                }
            })
                .then(response => {
                    this.props.setLoginSession(response);
                    this.setState({ error: null });
                })
                .catch(error => {
                    console.log('Microsoft login error: ', error.response);
                    this.loginError(error.response);
                });
        }
    }

    loginError(response) {
        this.setState({
            error: response.data.error_description || response.data.message
        });
    }

    googleFailure = (error) => {
        this.setState({ autoLoginInvoked: true });
        //TODO handle google oauth integration errors
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    userLogin(credentials) {
        let qs = require('qs');
        axios.post(EndpointsGetter.getAuthEndpoint(), qs.stringify({
            username: credentials.email,
            password: credentials.password,
            client_id: 'spring-security-oauth2-read-write-client',
            grant_type: 'password'
        }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic c3ByaW5nLXNlY3VyaXR5LW9hdXRoMi1yZWFkLXdyaXRlLWNsaWVudDpzcHJpbmctc2VjdXJpdHktb2F1dGgyLXJlYWQtd3JpdGUtY2xpZW50LXBhc3N3b3JkMTIzNA==',
                    'Fingerprint': this.props.fingerprint
                }
            })
            .then(response => {
                this.props.setLoginSession(response);
                this.setState({ error: null });
            })
            .catch(error => {
                this.loginError(error.response);
            });
    }

    render() {
        const { classes, email } = this.props;

        return (
            <Card className={classNames(classes.card)}>
                <CardContent className="flex flex-col items-center justify-center p-32">
                    <Typography variant="title" className="card-title">Log in to your account</Typography>
                    <Formsy
                        onValidSubmit={(model) => this.userLogin(model)}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center w-full"
                    >
                        <div style={{ color: 'red', marginBottom: 15 }}>
                            {this.state.error != null ? this.state.error : null}
                        </div>
                        <TextFieldFormsy
                            className="mb-16"
                            type="email"
                            name="email"
                            label="Enter Email"
                            value={email}
                            validations={{
                                isEmail: true,
                            }}
                            validationErrors={{
                                isEmail: 'This is not a valid email',

                            }}
                            required
                        />

                        <TextFieldFormsy
                            className="mb-16"
                            type="password"
                            name="password"
                            label="Enter password"
                            validations={{
                                minLength: 4
                            }}
                            validationErrors={{
                                minLength: 'Password needs to be at least 4 characters'
                            }}
                            required
                        />

                        <Button
                            type="submit"
                            variant="raised"
                            color="primary"
                            className="w-full mx-auto mt-16 normal-case"
                            aria-label="SEND RECOVERY LINK"
                            disabled={!this.state.canSubmit}
                            value="legacy"
                        >
                            Log in
                        </Button>
                    </Formsy>

                    <span className='or-separator'>
                        OR
                    </span>
                    <GoogleLogin
                        clientId={Config.googleClientId}
                        onSuccess={this.googleSuccess}
                        onFailure={this.googleFailure}
                        render={renderProps => (
                            <button className='custom-google-button' ref={this.googleLogin} onClick={renderProps.onClick}>
                                <GoogleIcon />
                                <span style={{ padding: "10px 10px 10px 0px", fontWeight: '500' }}>
                                    Sign in with Google
                                </span>
                            </button>
                        )}
                    />
                    <MicrosoftLogin
                        clientId={Config.msClientId}
                        authCallback={this.microsoftAuthCallback}
                        buttonTheme='dark'
                        withUserData={true}
                        debug={true}
                        className='third-party-sign-in-btn my-24'
                    />
                    <div className='already-existing'>
                        <a href='/resetpassword'>Can't log in?</a>
                    </div>
                </CardContent>
            </Card>
        )
    }
}

LoginInvitedUser.propTypes = {
    fingerprint: PropTypes.string,
    email: PropTypes.string,
    setLoginSession: PropTypes.func
};

const mapDispatchToProps = {
    setUserData
};

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(LoginInvitedUser)));


// WEBPACK FOOTER //
// ./src/main/content/invited-users/LoginInvitedUser.js